import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { HeaderService } from "@shared/services/header.service";
import { MenuService } from "@shared/services/menu.service";
import { SignalRService } from '@shared/services/signalr.service';
import { isExpandedPage } from "@shared/utils/is-expanded-page";
import { filter, map, Observable } from 'rxjs';
import { ModalFormsService } from "./forms/services/modal-forms.service";

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'bolt';
  collapsedMenu = this.menuService.collapsedMenu;
  headerData = this.headerService.headerData;
  isExpandedWideRoute$: Observable<boolean> = this.router.events.pipe(
    filter(event => event instanceof NavigationEnd),
    map(() => isExpandedPage(this.router.url))
  );

  isGuestUser$: Observable<boolean> = this.router.events.pipe(
    filter(event => event instanceof NavigationEnd),
    map(() => this.router.url.includes('/guest/'))
  );

  constructor(
    private authService: AuthService,
    private menuService: MenuService,
    private router: Router,
    private modalFormsService: ModalFormsService,
    private signalRService: SignalRService,
    private headerService: HeaderService,
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => this.modalFormsService.closeAllFormsModals());

    if (this.authService.isAuthenticated) {
      this.signalRService.startConnection().subscribe({
        next: () => {
          console.log('SignalR connection successfully started');
        },
        error: (error) => {
          console.error('Failed to start SignalR connection:', error);
        },
      });
    }
  }

  public get isAuthenticated() {
    return this.authService.isAuthenticated;
  }
}
